import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Button, List, Modal, Icon, Switch, InputItem, Toast } from 'antd-mobile';
import { TextDialog } from '../../../components/textDialog';
import { ShareBtn } from '../../../components/icons/share';
import { BackBtn } from '../../../components/icons/back';
import { uploadImg, setHomepageStatus } from '../../commonAction';
import { Vh5Bar } from '../../../components/bar';
import { reAuth } from '../../../utils/weixin';
import { _track, login } from '../../../utils/track';
import { base64ToBlob, blobToFile, readCookie, createCookie, isWeixin, getQueryString } from '../../../utils/common';
import { getCopyrightUserInfo } from '../../commonAction';
import { getCAPTCHA, bindPhone, bindPhone_PC, getWxInfo } from './action';
import './index.scss';
import '../../../utils/weixin-login-window';

let isMobile = false;
if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
	//移动端
	isMobile = true;
}
const mapStateToProps = state => {
	return {
		siteSwitch: state.AdminReducers.siteSwitch
	};
};

function CopyrightLogin() {
	let history = useHistory();
	const mapState = useCallback(mapStateToProps, []);
	const { siteSwitch } = useMappedState(mapState);
	let dispatch = useDispatch();
	let [disableSendCode, setDisableSendCode] = useState(false);
	let [countdownSeconds, setCountdownSeconds] = useState(0);
	const [pageData, setPageData] = useState({
		phone: '',
		code: '',
		winHeight: 0
	});
	function handlePhoneChange(val) {
		pageData.phone = val;
		console.log(val);
		console.log(pageData.phone);
		setPageData({ ...pageData });
	}
	function handleCodeChange(val) {
		pageData.code = val;
		setPageData({ ...pageData });
	}
	function validInput(phone, code) {
		phone = phone.trim();
		code = code.trim();
		if (!phone) {
			Toast.fail('手机号不能为空');
			return;
		}
		if (!code) {
			Toast.fail('验证码不能为空');
			return false;
		}
		let validPhone = /^1\d{10}$/.test(phone);
		let validCode = /^\d{6}$/.test(code);
		if (!validPhone) {
			Toast.fail('手机号格式错误');
			return false;
		}
		if (!validCode) {
			Toast.fail('验证码格式错误');
			return false;
		}
		return true;
	}

	function bindUserPhone() {
		let phone = pageData.phone;
		let authCode = pageData.code;
		let weixin_token = readCookie('weixintoken');
		if (!validInput(phone, authCode)) {
			return;
		}

		let successCB = data => {
			console.log('data', data);
			createCookie('userToken', data.token, 180);
			createCookie('copyrightuserId', data.userId, 180);
			createCookie('copyrightphone', phone, 180);
			window['userToken'] = data.token;
			window['copyrightuserId'] = data.userId;
			window['copyrightphone'] = data.phone;
			Toast.success('登录成功');
			let pathname = window.decodeURIComponent(getQueryString('redirect_pathname') || '') || '/vpmobile/copyright/home';
			history.push({
				pathname
			});
			login();
			_track({
				trackName: 'toutu_login_page',
				payload: {
					...data,
					phone,
					page_action_name: 'login',
					Login_Action: '登陆'
				}
			});
		};
		let failCB = data => {
			console.log('error data', data);
			Toast.fail('登录失败，请重试');
			// 20206 是 token 为空，20207 是不存在或已过期
			// alert(data.errorCode);
			if (data.errorCode === 20206 || data.errorCode === 20207) {
				// alert(data.errorCode);
				createCookie('weixintoken', '', -1);
				setTimeout(() => {
					// alert('reAuth');
					reAuth({ toPage: 'login', scopeType: 'snsapi_userinfo' });
				}, 1000);
			}
			if (timer) {
				clearInterval(timer);
			}
			setCountdownSeconds(0);
			setDisableSendCode(false);
//			_track({
//				trackName: 'toutu_login_page',
//				payload: {
//					...data,
//					phone,
//					page_action_name: 'login'
//				}
//			});
		};
		let params = null;
		if (isWeixin()) {
			params = { phone, authCode, token: weixin_token };
			dispatch(bindPhone(params, successCB, failCB));
		} else {
			params = { phone, authCode };
			dispatch(bindPhone_PC(params, successCB, failCB));
		}
	}
	let timer = null;
	function getCode() {
		setDisableSendCode(true);
		dispatch(
			getCAPTCHA(
				{ phone: pageData.phone },
				data => {
					console.log('data', data);
					Toast.success('验证码已发送', 1);
					countdown();
					document.getElementsByTagName('input')[1].focus();
					_track({
						trackName: 'toutu_login_page',
						payload: {
							...data,
							phone: pageData.phone,
							page_action_name: 'login-send-code',
							Login_Action: '发送验证码'
						}
					});
				},
				data => {
					console.log(document.getElementsByTagName('input')[0]);
					document.getElementsByTagName('input')[0].focus();
					console.log('error data', data);
					Toast.fail('获取验证码失败', 1);
					clearInterval(timer);
					setDisableSendCode(false);
					_track({
						trackName: 'toutu_login_page',
						payload: {
							...data,
							phone: pageData.phone,
							page_action_name: 'login-send-code'
						}
					});
				}
			)
		);
	}
	function countdown() {
		countdownSeconds = 60;
		timer = setInterval(() => {
			countdownSeconds = countdownSeconds - 1;
			if (countdownSeconds === 0) {
				if (timer) {
					clearInterval(timer);
				}
				setDisableSendCode(false);
			}
			if (countdownSeconds <= 0) {
				countdownSeconds = 0;
			}
			setCountdownSeconds(countdownSeconds);
		}, 1000);
	}
	function onBlurForIOS() {
		setTimeout(() => {
			// document.body.scrollTop = document.body.scrollTop;
			window.scrollTo(0, 0);
		});
	}

	useEffect(() => {
		let userToken = readCookie('userToken') || window['userToken'];
		let copyrightuserId = readCookie('copyrightuserId') || window['copyrightuserId'];
		if (userToken && copyrightuserId) {
			window.location.href = '/vpmobile/copyright/home';
		}

		if (!pageData.winHeight) {
			pageData.winHeight = window.innerHeight;
			setPageData({ ...pageData });
			window.addEventListener('resize', () => {
				if (document.querySelector('footer')) {
					if (window.innerHeight === pageData.winHeight) {
						document.querySelector('footer').style.display = 'block';
					} else {
						document.querySelector('footer').style.display = 'none';
					}
				}
			});
		}
	}, [dispatch, pageData, setPageData]);
	function wxLogin() {
		let redirectUri = window.location.href;
		redirectUri = redirectUri.replace('login', 'wxLogin');
		// window.__WXLOGINWINDOW__.open( redirectUri );
		// redirectUri = 'https://gallery-fat.vphotos.cn/vpmobile/copyright/wxLogin';
		let params = { redirectUri };
		let successCB = data => {
			window.__WXLOGINWINDOW__.open(data.wxUrl);
		};
		dispatch(getWxInfo(params, successCB));
	}
	window._WXLOGINCB_ = function(data) {
		console.log('_WXLOGINCB_', data);
		createCookie('userToken', data.token, 180);
		createCookie('copyrightuserId', data.userId, 180);
		createCookie('copyrightphone', data.phone, 180);
		window['userToken'] = data.token;
		window['copyrightuserId'] = data.userId;
		window['copyrightphone'] = data.phone;
		let pathname = window.decodeURIComponent(getQueryString('redirect_pathname') || '') || '/vpmobile/copyright/home';
		history.push({
			pathname
		});
	};
	return (
		<div>
			{isMobile ? (
				<div className="copyright copyright-login">
					<section className="login-container">
						<div className="login-box">
							<picture className="brand-box"></picture>
							<section className="form">
								<InputItem value={pageData.phone} onChange={handlePhoneChange} onBlur={onBlurForIOS} placeholder="输入手机号" maxLength="11" prefixListCls="phone"></InputItem>
								<div className="code-wrapper">
									<InputItem value={pageData.code} onChange={handleCodeChange} onBlur={onBlurForIOS} placeholder="输入验证码" maxLength="6" prefixListCls="code"></InputItem>
									<Button type="primary" className="get-code-btn" onClick={getCode} disabled={disableSendCode}>
										获取验证码 {countdownSeconds ? `(${countdownSeconds})` : ''}
									</Button>
								</div>
								<Button type="primary" className="bind" onClick={bindUserPhone}>
									登录
								</Button>
							</section>
						</div>
					</section>
					<footer>
						<div className="info">
							<Link to="/vpmobile/copyright/about">关于投图</Link> ｜ <Link to="/vpmobile/copyright/notice">版权声明</Link> ｜{' '}
							<a href="/vpmobile/static/html/partner/photograper.html">合作摄影师</a> ｜ <a href="/vpmobile/static/html/partner/index.html">合作机构</a> <br /> 客服电话{' '}
							<a href="tel:4008065775">400-806-5775</a>
						</div>
						<div className="copyright">
							© 投图 All Rights Reserved.
							<br />
							唯存（上海）网络科技有限公司沪ICP备15052682号-2
						</div>
					</footer>
				</div>
			) : (
				<div className="copyright copyright-login2">
					<div className="wx-qr">
						<div className="wx-inner">
							<div
								className="close-wx"
								onClick={() => {
									history.goBack();
								}}>
								<i>&#xe652;</i>
							</div>
							<div className="wx-left"></div>
							<div className="wx-right">
								<div className="login-tit">登录</div>
								<section className="form">
									<InputItem value={pageData.phone} onChange={handlePhoneChange} onBlur={onBlurForIOS} placeholder="输入手机号" maxLength="11" prefixListCls="phone"></InputItem>
									<div className="code-wrapper">
										<InputItem value={pageData.code} onChange={handleCodeChange} onBlur={onBlurForIOS} placeholder="输入验证码" maxLength="6" prefixListCls="code"></InputItem>
										<div type="primary" className="get-code-btn" onClick={getCode}>
											获取验证码 {countdownSeconds ? `(${countdownSeconds})` : ''}
										</div>
									</div>
									<Button type="primary" className="bind" onClick={bindUserPhone}>
										登录
									</Button>
								</section>
								<div className="wx-icon">
									<i className="" onClick={wxLogin}>
										&#xe66e;
									</i>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
export { CopyrightLogin };
